/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { GlobalAuthContext, GlobalLoaderContext } from "store/context";
import { ToastContainer } from "react-toastify";
import useBackgroundOsndImportService from "./services/osnd-import-service";
import Crypt from "utils/src/crypt";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./constants/Routes";
import Access from "constants/Access";
import TextMessages from "@fitinsur/constants/TextMessages";

// Routes

import LoginPage from "containers/login";
import ForgotPasswordPage from "containers/forgot_password";
import ChangePasswordPage from "containers/change_password/";
import PrivateRoute from "components/PrivateRoute";
import ListPage from "containers/list";
import EditEnquirity from "containers/edit";
import HomePage from 'containers/home';
import EditCreateAnalysis from "containers/creditAnalysis/edit";
import CreditAnalysisCCG from "containers/creditAnalysis/ccg";
import CreditAnalysisCCGEdit from "containers/creditAnalysis/ccg-edit";
import Plans from "containers/plans";
import PlansRCG from "containers/plans-rcg";
import PaymentPageV2 from "containers/payment_v2";
import QuoteIssue from "containers/issue";
import DocumentManagement from "containers/documentManagement";
import QuoteDocument from "containers/quoteDocument";
import QuoteLetter from "containers/quoteLetter";
import PaymentPack from "containers/paymentPack";
import CreditAnalysis from 'containers/creditAnalysis';
import Management from '@fitinsur/containers/management';
import ManagementPerson from '@fitinsur/containers/management-edit-person';
import ManagementUser  from '@fitinsur/containers/management-edit-user';
import ManagementAccessRole from '@fitinsur/containers/management-edit-access-role';
import ManagementAccessGroup from '@fitinsur/containers/management-edit-access-group';
import ManagementEconomicIndexersImport from '@fitinsur/containers/management-edit-economic-indexers';
import { ManagementDocumentParams } from '@fitinsur/containers/management-edit-document-params';
import PoliciesAndEndorsements from 'containers/policiesAndEndorsements';
import VerifyDocsSigned from "containers/VerifyDocsSigned";
import StampStatusList from 'containers/stamps_status_list';
import AdjustmentsAndCorrections from 'containers/endorsementAdjustmentsCorrections';
import AdjustmentsAndCorrectionsPolicy from 'containers/endorsementAdjustmentsCorrectionsPolicy';
import Renewals from 'containers/renewals';

//Master policy
import { LoaderContextProvider } from "@fitinsur/contexts/LoaderContext";
import { TextMessageProvider } from "@fitinsur/contexts/TextMessageContext";
import { Loader } from "@fitinsur/components";
import { ReportExportService } from '@fitinsur/components';

console.log = () => true;

const App = () => {
  const [loading, setLoading] = React.useState(false);
  const crypt = new Crypt();
  const loadingState = {
    active: loading,
    toggle: () => setLoading(!loading),
    start: () => setLoading(true),
    stop: () => setLoading(false),
  };

  const authState = JSON.parse(localStorage.getItem('fitinsur-session')) && JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-sompo']
    ? crypt.isValidToken(
      crypt.parseJwt(crypt.decryptJson(JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-sompo']).token)
        .exp
    )
      ? crypt.decryptJson(JSON.parse(localStorage.getItem('fitinsur-session'))['fitinsur-sompo'])
      : {
        status: false,
        username: "",
        token: "",
        person_product: [],
        user_region: "",
        firstLogin: false,
        changedPassword: false,
        forgotPassword: false,
      }
    : {
      status: false,
      username: "",
      token: "",
      person_product: [],
      user_region: "",
      firstLogin: false,
      changedPassword: false,
      forgotPassword: false,
    };

  useBackgroundOsndImportService();
  return (
    <LoaderContextProvider>
      <TextMessageProvider>
        <ReportExportService projectBr={true}>
          <ToastContainer newestOnTop />
          <Router basename={process.env.PUBLIC_URL}>
            <Switch>
              <Route
                isAuthenticated={authState.status}
                path={Routes.LOGIN}
                component={LoginPage}
              />

              <Route
                isAuthenticated={authState.status}
                path={Routes.VERIFY_DOCS_SIGNED}
                component={VerifyDocsSigned}
              />

              <Route
                isAuthenticated={authState.status}
                path={Routes.FORGOTPASSWORD}
                component={ForgotPasswordPage}
              />

              <Route
                isAuthenticated={authState.status}
                path={Routes.CHANGEPASSWORD}
                component={ChangePasswordPage}
              />

            {/* ROTA ALTERNATIVA DE LIST */}
            <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.HOME}
                component={HomePage}
                routePermissions={Access.MENU_ACCESS.DASHBOARD}
            />
            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.ENQUIRIES}
              component={ListPage}
              routePermissions={Access.LIST}
            />
            <PrivateRoute
              isAuthenticated={authState.status}
              path={Routes.LIST}
              component={ListPage}
              routePermissions={Access.LIST}
            />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.LIST}
                component={ListPage}
                routePermissions={Access.LIST}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.CREATEENQUIRITY}
                component={EditEnquirity}
                routePermissions={Access.ROUTE_CREATEENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.EDITENQUIRITY}
                component={EditEnquirity}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.CREATECREDITANALYSIS}
                component={EditCreateAnalysis}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.EDITCREDITANALYSIS}
                component={EditCreateAnalysis}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.CREDITANALYSISCCG}
                component={CreditAnalysisCCG}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.CREDITANALYSISCCGEDIT}
                component={CreditAnalysisCCGEdit}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.STAMPS_STATUS_LIST}
                component={StampStatusList}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.QUOTESPLANS}
                component={Plans}
                routePermissions={Access.ROUTE_QUOTESPLANS}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.QUOTESPLANS_RCG}
                component={PlansRCG}
                routePermissions={Access.ROUTE_QUOTESPLANS_RCG}
              />              

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.PAYMENT}
                component={PaymentPageV2}
                routePermissions={Access.ROUTE_PAYMENT}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.QUOTE_ISSUE}
                component={QuoteIssue}
                routePermissions={Access.ROUTE_QUOTE_ISSUE}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.DOCUMENTMANAGEMENT}
                component={DocumentManagement}
                routePermissions={Access.ROUTE_DOCUMENTMANAGEMENT}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.QUOTE_LETTER}
                component={QuoteLetter}
                routePermissions={Access.ROUTE_QUOTESPLANS}
              />
              {/* FIM ROTAS SOMPO */}

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.QUOTEDOCUMENT}
                component={QuoteDocument}
                routePermissions={Access.ENQUIRY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.PAYMENTPACK}
                component={PaymentPack}
                routePermissions={Access.ENQUIRY}
              />

              <PrivateRoute isAuthenticated={authState.status}
                path={Routes.CREDIT_ANALYSIS}
                component={CreditAnalysis}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute isAuthenticated={authState.status}
                path={Routes.ADJUSTMENTS_AND_CORRECTIONS}
                component={AdjustmentsAndCorrections}
                routePermissions={Access.ROUTE_ADJUSTMENTS_AND_CORRECTIONS}
              />

              <PrivateRoute isAuthenticated={authState.status}
                path={Routes.ADJUSTMENTS_AND_CORRECTIONS_POLICY}
                component={AdjustmentsAndCorrectionsPolicy}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_PERSON_CREATE}
                component={ManagementPerson}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_PERSON}
                routePermissions={Access.MANAGEMENT_PERSON}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_PERSON_EDIT}
                component={ManagementPerson}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_PERSON}
                routePermissions={Access.MANAGEMENT_PERSON}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_USER_EDIT}
                component={ManagementUser}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_USER}
                routePermissions={Access.MANAGEMENT_USER}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_USER_CREATE}
                component={ManagementUser}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_USER}
                routePermissions={Access.MANAGEMENT_USER}
              />              

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ACCESS_GROUP_CREATE}
                component={ManagementAccessGroup}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ACCESS_GROUP}
                routePermissions={Access.MANAGEMENT_ACCESS_GROUP}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ACCESS_GROUP_EDIT}
                component={ManagementAccessGroup}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ACCESS_GROUP}
                routePermissions={Access.MANAGEMENT_ACCESS_GROUP}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ACCESS_GROUP_VIEW}
                component={ManagementAccessGroup}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ACCESS_GROUP}
                routePermissions={Access.MANAGEMENT_ACCESS_GROUP}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ACCESS_ROLE_VIEW}
                component={ManagementAccessRole}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ACCESS_ROLE}
                routePermissions={Access.MANAGEMENT_PROFILE}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ACCESS_ROLE_EDIT}
                component={ManagementAccessRole}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ACCESS_ROLE}
                routePermissions={Access.MANAGEMENT_PROFILE}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ACCESS_ROLE_CREATE}
                component={ManagementAccessRole}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ACCESS_ROLE}
                routePermissions={Access.MANAGEMENT_PROFILE}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_ECONOMIC_INDEXERS_CREATE}
                component={ManagementEconomicIndexersImport}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_ECONOMIC_INDEXERS}
                routePermissions={Access.MANAGEMENT_ECONOMIC_INDEXERS}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.MANAGEMENT_DOCUMENT_PARAMS_EDIT}
                component={ManagementDocumentParams}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT_DOCUMENT_PARAMS}
                routePermissions={Access.MANAGEMENT_DOCUMENT_PARAMS}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                exact path={Routes.MANAGEMENT}
                component={Management}
                routeTextMessages={TextMessages.ROUTE_MANAGEMENT}
                routePermissions={Access.MANAGEMENT}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.POLICIES}
                component={PoliciesAndEndorsements}
                routePermissions={Access.ROUTE_POLICIES_AND_ENDORSEMENTS_LIST}
              />

              <PrivateRoute
                isAuthenticated={authState.status}
                path={Routes.RENEWALS}
                component={Renewals}
                routePermissions={Access.ROUTE_EDITENQUIRITY}
                routeTextMessages={TextMessages.ROUTE_RENEWALS}
              />

              <Redirect to={authState.status ? Routes.LIST : Routes.LOGIN} />
            </Switch>
          </Router>
          <GlobalAuthContext.Provider value={authState} />
          <Loader fullScreen />
        </ReportExportService>
      </TextMessageProvider>
    </LoaderContextProvider>
  );
};

export default App;
